import type { RefObject } from 'react';
import { findTransitionController } from '../../../util/core-transition-component';
import type { CtaRefType } from '../../../util/cta/cta.data';

interface BlackholeCtaRefs {
  elementRef: RefObject<HTMLElement | null>;
  titleRef: RefObject<HTMLHeadingElement | null>;
  buttons: RefObject<Array<RefObject<CtaRefType | null>> | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, buttons }: BlackholeCtaRefs,
): void {
  const titleController = findTransitionController(titleRef);

  if (titleController) {
    timeline.add(titleController.getTimeline('in') as gsap.core.Timeline, 0);
  }

  buttons?.current?.forEach((buttonRef, index) => {
    const buttonController = findTransitionController(buttonRef);
    if (buttonController) {
      timeline.add(buttonController.getTimeline('in') as gsap.core.Timeline, 0.5 + index * 0.1);
    }
  });
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, buttons }: BlackholeCtaRefs,
): void {
  const titleController = findTransitionController(titleRef);

  if (titleController) {
    timeline.add(titleController.getTimeline('out') as gsap.core.Timeline);
  }

  timeline.addLabel('outComplete', '-=0');

  buttons?.current?.forEach((buttonRef) => {
    const buttonController = findTransitionController(buttonRef);
    if (buttonController) {
      timeline.add(buttonController.getTimeline('out') as gsap.core.Timeline, 'outComplete');
    }
  });
}
